module.exports = require('./src/BambuserPlayer.react').default;
if (window) {
  // TODO: inject configuration into the jade template
  window.CONFIG = CONFIG || {}; // eslint-disable-line no-undef
}
